import { render, staticRenderFns } from "./mailchimp.vue?vue&type=template&id=55785726&scoped=true&"
import script from "./mailchimp.vue?vue&type=script&lang=js&"
export * from "./mailchimp.vue?vue&type=script&lang=js&"
import style0 from "./mailchimp.vue?vue&type=style&index=0&id=55785726&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55785726",
  null
  
)

export default component.exports